import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHomeIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M17 21H7C4.79086 21 3 19.2091 3 17V10.7076C3 9.30883 3.73061 8.01172 4.92679 7.28676L9.92679 4.25646C11.2011 3.48418 12.7989 3.48418 14.0732 4.25646L19.0732 7.28676C20.2694 8.01172 21 9.30883 21 10.7076V17C21 19.2091 19.2091 21 17 21Z",
		stroke: "white",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9 17H15",
		stroke: "white",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgHomeIcon;
